import { AxiosInstance } from 'axios'
import { CATALOG_ENDPOINTS } from 'api/ApiRoutes'
import { Country, State, StateCategory } from 'types/catalog'

class CatalogApi {
  constructor(private axiosInstanceNoVersion: AxiosInstance) {}

  getCountries = async () => {
    const d = await this.axiosInstanceNoVersion.get<{
      data: Country[]
    }>(CATALOG_ENDPOINTS.COUNTRIES)
    return d.data.data
  }

  getStates = async ({
    countryCode,
    category
  }: {
    countryCode: string
    category?: StateCategory[]
  }) => {
    const d = await this.axiosInstanceNoVersion.get<{
      data: State[]
    }>(CATALOG_ENDPOINTS.STATES, {
      params: {
        country: countryCode,
        ...(category && { category: category.join(',') })
      }
    })
    return d.data.data
  }
}

export default CatalogApi
